// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"8e286da3","480":"bb888240","521":"5b8b87be","787":"1d8a7665","797":"81ee885d","828":"10bf53b3","920":"465bb503","943":"922e7166","983":"593c0e4b","999":"46582e35"}[chunkId] + ".chunk.js";
};